import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import Image from 'app/components/Image';
import ViewportObservable from 'app/components/ViewportObservable';

const windowWidth = window.innerWidth;
const fontSize = parseInt(window.getComputedStyle(document.body).fontSize);

const styles = () => ({
  container: {
    float: 'left',
    //width: containerWidth + 'px',
    paddingBottom: '1rem'
  },
  column: {
    float: 'left'
  },
  image: {
    float: 'left',
    padding: '3px'
  },
  placeholder: {
    width: '100%',
    height: '100%',
    background: '#fff'
  }
});

class ImageGallery extends React.Component {
  constructor(props) {
    super(props);

    // get grid dimensions from gallery worker
    this.gridDimensions = null;

    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    this.loadGridDimensions();
  }

  loadGridDimensions() {
    const { galleryWorker, columns, photos } = this.props;
    this.galleryWidth = this.getContainerWidth();

    galleryWorker.getGridDimensions(this.galleryWidth, columns, photos, dimensions => {
      this.galleryDimensions = dimensions;
      this.setState({ loading: false });
    });
  }

  getContainerWidth() {
    // return width in px.
    // only vw setting is supported
    const { width } = this.props;

    if (!width || !width.match(/vw/)) {
      return windowWidth - fontSize; // - 1rem for scrollbar
    }

    let percent = parseInt(width.match(/\d+/)[0]) / 100;
    return windowWidth * percent;
  }

  render() {
    const {
      classes,
      index,
      photos,
      resolution,
      // initVisible,
      dateHeader,
      viewport,
      dateStr
    } = this.props;

    if (this.state.loading) {
      return null;
    }

    // hotfix for Kiosk component
    //if (window.galleryHeights) {
    //  window.galleryHeights[index] = this.galleryDimensions.height;
    //}

    let colsJsx = this.galleryDimensions.columns.map((col, colIndex) => {
      let images = col.moments.map((m, i) => {
        let photo = photos[m.index];

        let style = {
          width: m.width + 'px',
          height: m.height + 'px'
        }

        let attrs = {
          photo,
          top: m.top
        }

        return (
          <div className={classes.image} style={style}>
            <ViewportObservable
              viewport={viewport}
              viewportKey={`moment-${photo.moment_id}`}
              initVisible={i < 8}
              keepVisible={true}
            >
              <Image key={`moment-${photo.moment_id}`}
                //visible={initVisible && i < 6}
                resolution={resolution}
                attrs={attrs}
                width={style.width}
                height={style.height}
                removeImage={momentId => this.props.removeImage(momentId)}
                selectEnabled={this.props.selectEnabled && !photo.purchased}
                removeEnabled={this.props.removeEnabled}
                cart={this.props.cart}
                selectedMomentIds={this.props.selectedMomentIds}
                onSelect={this.props.onSelect}
                onUnselect={this.props.onUnselect}
                checkboxStyle={this.props.checkboxStyle}
                printsEnabled={this.props.printsEnabled}
                viewImageOnTap={this.props.viewImageOnTap}
                viewport={viewport}
                displayAccessCodes={this.props.displayAccessCodes}
              />
            </ViewportObservable>
          </div>
        );
      });

      return (
        <div key={`col-${index}-${colIndex}`} className={classes.column} style={{width: col.width + 'px'}}>

          {images}
        </div>
      );
    });

    //let containerStyle = null;
    //if (settings.hide_order_details || user.unlocked) {
    //  containerStyle = { width: '100vw' };
    //}
    let containerStyle = {
      width: `${this.galleryWidth}px`,
      height: `${this.galleryDimensions.height}px`
    };

    return (
      <div className={classes.container} style={containerStyle}>
        <ViewportObservable
          viewport={viewport}
          viewportKey={`gallery-${dateStr}`}
          initVisible={index < 2}
          keepVisible={true}
        >
          {dateHeader}
          {colsJsx}
        </ViewportObservable>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  user: state.kioskReducer.user
});

export default connect(mapStateToProps, {})(withStyles(styles)(ImageGallery));
